import React, { useLayoutEffect } from 'react';

import keycloak from 'app/config/keycloak';
import { clearAuth } from 'app/store/reducers/app/authentication';
import { useAppDispatch } from 'app/store/store';
import { setCurrentAccountId } from 'app/shared/api/accountContext';

export const Logout = () => {
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch(clearAuth());
    setCurrentAccountId(null);

    const logoutUrl = keycloak.createLogoutUrl({
      redirectUri: window.location.origin,
    });

    window.location.href = logoutUrl;
  }, [dispatch]);

  return (
    <div className="p-5">
      <h4>Logged out successfully!</h4>
    </div>
  );
};

export default Logout;
